"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProviderBase = /** @class */ (function () {
    function ProviderBase(request) {
        this.request = request;
    }
    return ProviderBase;
}());
exports.ProviderBase = ProviderBase;
//# sourceMappingURL=ProviderBase.js.map